<template>
    <v-container fluid>
        <Form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.add')"
        />
    </v-container>
</template>

<script>
import Form from './Form'
import LandingPage from '@/models/LandingPage'

export default {
    components: {
        Form,
    },

    computed: {
        model() {
            let model = new LandingPage()
            return model
        },
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
